import React from 'react';
export function Mail(props) {
    return (
        <svg {...props}>
            <path d="M488.6 97.4c-3.6-18.7-19.7-33.8-38.5-36.3-.9-.1-1.7-.3-2.5-.4H53c-2.2.4-4.4.7-6.6 1.2-18.2 4.1-32.4 19.7-35 38.2-.1.9-.3 1.7-.4 2.6v295.2c.4 2.2.6 4.4 1.2 6.5 5 18.5 16.9 30.1 35.6 34.5 1.9.5 3.9.7 5.9 1h393.1c2-.3 4-.6 6-1 18.9-3.7 33.9-19.8 36.3-38.9.1-.9.3-1.9.4-2.8V103.4c-.3-2-.5-4-.9-6zm-35.1 251.5L330.8 254h-1.3l124.1-95.9c-.1 63.6-.1 127.2-.1 190.8zM51.5 98.4c1.6-1.1 3.3-1.6 5.2-1.7h385.6c3.6 0 6.7 1 9 3.9 1.5 1.9 2.1 4 2.2 6.3v5.7L250 269.9 47 113v-5.2c0-3.9 1.2-7.1 4.5-9.4zM47 348.5v-190L170.5 254h-1.3L47 348.5zm400.3 54.4c-1.4.6-3 .8-4.5.8-3.5.1-7 0-10.4 0H58.3c-3.6 0-6.7-1-9-3.9-1.3-1.6-2-3.5-2.1-5.6v-.4l152.3-117.7 39.3 30.4c3.3 2.5 7.2 3.8 11 3.8h.8c3.8 0 7.7-1.2 11-3.8l39.3-30.4 152.8 118.1c-.6 4.1-2.5 7.1-6.4 8.7z" />
        </svg>
    );
}

Mail.defaultProps = {
    viewBox: '0 0 500 500'
};

export default Mail;
